import { render, staticRenderFns } from "./QuestionnaireEditSection.vue?vue&type=template&id=5bbec172"
import script from "./QuestionnaireEditSection.vue?vue&type=script&lang=js"
export * from "./QuestionnaireEditSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports